import { Box, HeadingLevelProvider, OwnStackProps, PageLayoutToolbar, Stack } from '@sixfold/common-ui';
import classnames from 'classnames';
import * as React from 'react';

import { ErrorBoundary } from '../error_boundary';

import * as styles from './toolbar.css';

interface ToolbarProps {
  children?: React.ReactNode;
  className?: string;
}

export const Toolbar: React.FunctionComponent<React.PropsWithChildren<ToolbarProps>> = ({
  children,
  className,
  ...rest
}) => (
  <PageLayoutToolbar>
    <Box {...rest} className={classnames(styles.toolbar, className)}>
      <Stack gap="small" direction="column" wrap={false}>
        <HeadingLevelProvider>
          <ErrorBoundary>{children}</ErrorBoundary>
        </HeadingLevelProvider>
      </Stack>
    </Box>
  </PageLayoutToolbar>
);

interface ToolbarRowProps {
  children?: React.ReactNode;
  className?: string;
}

export const ToolbarRow: React.FunctionComponent<React.PropsWithChildren<ToolbarRowProps>> = ({
  children,
  className,
  ...rest
}) => (
  <Stack {...rest} gap="medium" rowGap="small" alignItems="center" justifyContent="space-between" className={className}>
    {children}
  </Stack>
);

interface ToolbarRowSectionProps extends OwnStackProps {
  children?: React.ReactNode;
  className?: string;
}

export const ToolbarRowSection: React.FunctionComponent<React.PropsWithChildren<ToolbarRowSectionProps>> = ({
  children,
  className,
  ...rest
}) => (
  <Stack gap="small" alignItems="center" {...rest} className={className}>
    {children}
  </Stack>
);
